module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-view"
  }, [(!_vm.tbcMode && !_vm.embedMode) ? _c('el-alert', {
    staticClass: "notice",
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": "",
      "title": ""
    }
  }, [_vm._v("\n    PP匠2.0版本正式发布，推出会员计划，为用户带来更实用完善的服务，"), _c('a', {
    staticClass: "text-btn",
    attrs: {
      "href": "/price",
      "target": "_blank"
    }
  }, [_vm._v("了解详情")]), _vm._v("。\n  ")]) : _vm._e(), _vm._v(" "), (/^\/categories/.test(_vm.$route.path) || _vm.hasProjects) ? _c('category') : _vm._e(), _vm._v(" "), _c('projects-list', {
    ref: "projects-list",
    on: {
      "has-projects": function($event) {
        _vm.hasProjects = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1e5947e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = 956
// module chunks = 3